export enum ReportConfigurationSection {
    GeneralInformation = 'GENERAL_INFORMATION',
    HeatPumpPlan = 'HEAT_PUMP_PLAN',
    PVPlan = 'PV_PLAN',
    VentilationPlan = 'VENTILATION_PLAN',
    FullSystem = 'FULL_SYSTEM',
    LegalNotice = 'LEGAL_NOTICE'
}
